export default __webpack_public_path__ + "static/reviewstab-cbca095bf1fd07b234fff395fd1c1218.jpg";